import { customRef } from 'vue'

export const DEFAULT_DELAY = 500

export default (value = '', delay = DEFAULT_DELAY) => {
  let timeout

  return customRef((track, trigger) => {
    return {
      get () {
        track()
        return value
      },
      set (newValue) {
        clearTimeout(timeout)

        timeout = setTimeout(() => {
          value = newValue
          trigger()
        }, delay)
      }
    }
  })
}
